import React, { useEffect } from 'react'
import { Select as Multiselect } from '@material-ui/core'
import { urlAdd, urlAddExist, urlRemove, urlGet } from '../../../Utils/URL'
import { MenuItem } from 'material-ui'

export const MultiSelectCustomUnstyled = props => {
  const ITEM_HEIGHT = 48
  const ITEM_PADDING_TOP = 8
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 150,
      },
    },
    getContentAnchorEl: () => null,
  }

  useEffect(() => {
    const value = urlGet(props.label)
    const valueEl = props.options.find(element => element.value == value)
    if (value && valueEl && props.value != value) {
      props.onChange(
        {
          target: { value },
          stopPropagation: () => {},
          preventDefault: () => {},
        },
        0,
        value,
      )
    }
  }, [props.label, props.options])
  return (
    <div key={props.label + 'div'} className={props.className} id={props.id}>
      {!props.withoutLabel && props.label && <label>{props.label}</label>}
      <Multiselect
        multiple
        disableUnderline
        value={props.selectedCountries}
        onChange={(e, i, v) => {
          let data = e.target.value

          if (i.props.value.includes('All')) {
            const hasEnabledAllValue = e.target.value.includes('All')
            data = hasEnabledAllValue ? ['All'] : [props.userCountry]
          }
          if (!i.props.value.includes('All')) {
            data = e.target.value.filter(item => item !== 'All')
          }

          if (e.target.value.length === 0) {
            data = [props.userCountry]
          }
          props.setSelectedCountries(data)
          syncOnChangeWithUrl(
            props.enableMultiFilterValues,
            props.label,
            props.onChange,
            e,
            i,
            v,
          )
        }}
        style={{
          width: '150px',
          paddingLeft: '10px',
          border: '1px solid #E2E2FC',
        }}
        MenuProps={MenuProps}
      >
        {props.options.map(({ value, label }) => (
          <MenuItem
            key={label}
            value={label}
            style={{
              backgroundColor:
                props.selectedCountries &&
                props.selectedCountries.indexOf(label) > -1
                  ? '#E2E2FC'
                  : 'transparent',
            }}
          >
            {label}
          </MenuItem>
        ))}
      </Multiselect>
    </div>
  )
}

/**
 * Wrap an value onChange function with url syncing
 * @param {string} label The key to use in the url
 * @param {Function} func The original onChange function, expects the first
 * value to be the value, could be an array of values.
 * @returns {Function}
 */
const syncOnChangeWithUrl = (
  enableMultiFilterValues,
  label,
  onChange,
  e,
  i,
  selectedValue,
) => {
  if (selectedValue && (label === 'Period' || selectedValue !== 'All')) {
    enableMultiFilterValues
      ? urlAddExist(label, selectedValue)
      : urlAdd(label, selectedValue)
  } else {
    urlRemove(label)
  }
  return onChange(e, i, selectedValue)
}
